import React from 'react';
import {Link} from "react-router-dom";
import {Helper} from "./Helper";
import {Modal} from "react-spaceship-web";
import ReactDOM from "react-dom";

export default class StockAdjustment extends React.Component {
	constructor(props) {
		super(props);

		let _state = {};
		_state.params = {};
		window.Route.on({
			'/v2/stock_adjustment': () => {
				_state = {
					mode: 'list',
				};
			},
			'/v2/stock_adjustment/new': () => {
				_state = {
					mode: 'create',
				};
			},
			'/v2/stock_adjustment/:stock_adjustment_id': (params) => {
				_state = {
					mode: 'view',
					params: params,
				};
			},
			'/v2/stock_adjustment/:stock_adjustment_id/edit': (params) => {
				_state = {
					mode: 'edit',
					params: params,
				};
			},
		}).match();
		_state.shipment = false;
		_state.shipments = [];
		_state.is_loading = true;
		_state.qs = window.Global.getAllQueryStrings();
		this.state = _state;
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			window.Route.on({
				'/v2/stock_adjustment': () => {
					this.setState({
						mode: 'list',
						is_loading: true,
						shipment: false,
						shipments: [],
					}, () => {
						this.fetch();
					})
				},
				'/v2/stock_adjustment/new': () => {
					this.setState({
						mode: 'create',
						is_loading: true,
						shipment: false,
						shipments: [],

					}, () => {
						this.create();
					})
				},
				'/v2/stock_adjustment/:stock_adjustment_id': (params) => {
					this.setState({
						mode: 'view',
						is_loading: true,
						params: params,
						shipment: false,
						shipments: [],
					}, () => {
						this.view();
					});
				},
				'/v2/stock_adjustment/:stock_adjustment_id/edit': (params) => {
					this.setState({
						mode: 'edit',
						is_loading: true,
						params: params,
						shipment: false,
						shipments: [],
					}, () => {
						this.edit();
					});
				},
			}).match();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.setState({
				mode: 'list',
				is_loading: true,
				product: false,
				products: [],
				product_price_condition: [],
			}, () => {
				this.fetch();
			})
		}
	}

	componentDidMount() {
		if (this.state.mode === 'view') {
			this.view();
		}
		if (this.state.mode === 'list') {
			this.fetch();
		}
		if (this.state.mode === 'create') {
			this.create();
		}
		if (this.state.mode === 'edit') {
			this.edit();
		}
	}

	recalculateItem() {
		window.$('.Item_each').each(function () {
			window.$(this).find('input[name="user_input_quantity"]').trigger('focusout');
		});
	}

	prepare() {
		let $form = window.$(this.$parent);
		$form.find('input[name="responsibility_user_id"]').explorer({
			url: process.env.REACT_APP_DOMAIN + '/api/user',
			additionalData: {
				limit: 10
			},
			key: 'user',
			template: {
				list: (value) => {
					return window.Mustache.render('<a class="item"><div>{{name}}</div></a>', value);
				},
				selected: {
					text: 'name',
					value: 'id',
					placeholder: 'ไม่ระบุ'
				}
			}
		});

		this.$stock = $form.find('input[name="stock_id"]').explorer({
			url: process.env.REACT_APP_DOMAIN + '/api/stock',
			additionalData: {
				limit: 5,
				page: 1
			},
			key: 'stock',
			template: {
				list: '<a class="item flex row">{{name}}</a>',
				selected: {
					text: 'name',
					value: 'id',
					placeholder: 'ค้นหาคลังสินค้า'
				}
			},
			onSelected: () => {
				// $form.find('input[name="product_template_id"]').explorer('clear');
				// $form.find('.Item_each').remove();
				this.recalculateItem();
			},
			onUnSelected: () => {
				this.recalculateItem();
			}
		});

		$form.find('input[name="product_template_id"]').explorer({
			url: process.env.REACT_APP_DOMAIN + '/api/product_template',
			additionalData: () => {
				return {
					limit: 30
				}
			},
			key: 'product_template',
			template: {
				list: (value) => {
					return window.Mustache.render('<div class="item">{{name}}</div>', value);
				},
				selected: {
					display_template: '<div>{{name}}</div>',
					value: 'id',
					placeholder: 'ค้นหากิจกรรมประจำ'
				}
			},
			onSelected: (product_template) => {
				// $form.find('.Item_root').empty();
				product_template.product_template_item.map((product_template_item) => {
					if (window.$('.Item_root').find('div[data-product_id="' + product_template_item.product.id + '"]').length === 0) {

						let stock1 = Helper.getProductStock(
							product_template_item.product,
							$form.find('input[name="stock_id"]').val()
						);

						window.GlobalFunc.reactToDom(
							window.$(this.$parent).find('.Item_root'),
							StockAdjustmentItem, {
								$parent: window.$(this.$parent),
								mode: 'create',
								shipment_item: {
									id: '',
									quantity_ship: stock1.on_hand,
									ratio: product_template_item.product.sell_price[0].ratio,
									product: product_template_item.product,
								},
								product: {...product_template_item.product},
							}
						);
					}
					return false;
				})
			}
		});

		window.GlobalFunc.setupTag($form.find('input[name="tag[]"]'), {
			type: 'stock_adjustment',
			url: process.env.REACT_APP_DOMAIN + '/api/filter',
		});

	}

	create() {
		let response_running_number = [];
		let response_stock;
		window.Global.getDataViaMultiAjax().load({
			'running_number': {
				method: 'GET',
				url: process.env.REACT_APP_DOMAIN + '/api/running_number',
				data: {all: true},
				done: function (response) {
					if (!response.success) return false;
					response_running_number = response['running_number'];
				}
			},
			'stock': {
				method: 'GET',
				url: process.env.REACT_APP_DOMAIN + '/api/stock',
				data: {
					limit: 1
				},
				done: function (response) {
					if (!response.success) return false;
					response_stock = response;
				}
			}
		}).done(() => {

			this.setState({
				is_loading: false,
			}, () => {
				window.GlobalFunc.handleCodeInput({
					$node: window.$(this.$parent).find('.RunningNumber_root'),
					$custom_running_number: window.$(this.$parent).find('.custom-running-number'),
					running_number: response_running_number,
					running_number_id: 13
				});
				this.prepare();
				if (typeof response_stock !== 'undefined' && response_stock['stock'].length) {
					window.$.each(response_stock['stock'], (i, stock) => {
						window.$(this.$parent).find('input[name="stock_id"]').explorer('set value', stock);
					});
				}
			});
		});


	}

	edit() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/shipment',
			data: {
				shipment_id: this.state.params.stock_adjustment_id
			},
			done: (response) => {
				let shipment = response.shipment[0];
				this.setState({
					shipment: shipment,
					is_loading: false,
				}, () => {
					let $form = this.$parent.find('form');
					this.prepare();

					if (shipment['responsibility_user']) {
						$form.find('input[name="responsibility_user_id"]').explorer('set value', shipment['responsibility_user']);
					}

					if (this.state.mode === 'edit'
						&& this.state.shipment.is_done === 0
					) {
						if (shipment['stock']) {
							this.$stock.explorer('set selected', shipment['stock']);
						}
					}

					window.GlobalFunc.setValueTag(
						this.$parent.find('.Explorer[data-explorer_input_name="tag[]"]'),
						shipment['tag']
					);

					this.recalculateItem();

					$form.form2('init', {
						data: shipment
					});
				})
			}
		});
	}

	fetch() {
		// alert("Fetch");
		let data = window.Global.getAllQueryStrings();
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/shipment',
			data: {
				source: "stock_adjustment",
				...data,
			},
			done: (response) => {
				this.setState({
					shipments: response.shipment,
					is_loading: false,
				}, () => {
					this.$parent.find('.Table_root').tablePagination({
						disableContent: true,
						data: response.shipment,
						count: response.count,
						onClickPagination: (p) => {
							let qs = window.Global.getAllQueryStrings();
							qs.page = p;
							this.props.history.push(window.Global.getQueryStringLinkFromObject(qs));
						}
					});
				})
			},
			fail: () => {

			}
		});

	}

	view() {
		let data = window.Global.getAllQueryStrings();
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/shipment',
			data: {
				shipment_id: this.state.params.stock_adjustment_id,
				...data,
			},
			done: (response) => {
				this.setState({
					shipment: response.shipment[0],
					is_loading: false,
				})
			},
			fail: () => {

			}
		});
	}

	renderView() {
		// console.log(this.state);
		return (
			<div ref={(ref) => {
				this.$parent = ref;
			}} className="main ui container">
				<div id="HeaderTop_root">
					<div className="flex row wrap">
						<div className="ui huge breadcrumb" style={{margin: '0.3em 1.3rem 0 0'}}>
							<Link id="header" className="active section"
							      to={"/v2/stock_adjustment"}>ปรับสินค้าคงคลัง</Link>
							<span className="divider" style={{margin: '0 1rem'}}>/</span>
							<div className="active section">
								{this.state.shipment ? this.state.shipment.desc : ''}
							</div>
						</div>
						<div className="right floated">
							<Link id="addProductButton" to="/v2/stock_adjustment/new"
							      className="ui positive button">ปรับสินค้าคงคลังใหม่</Link>
						</div>
					</div>
				</div>
				<div
					className={this.state.is_table_loading ? "ui form tall padded stacked segment loading" : "ui form tall padded stacked segment"}>
					<div className="flex row center align left content align" style={{padding: '0 0 9px 0'}}>
						<h2 id="title" style={{margin: 0}}>ใบปรับสินค้าคงคลัง {this.state.shipment.desc}</h2>
						{
							!this.state.shipment.is_deleted ?
								<div className="flex row" data-is_deleted="0"
								     style={{position: 'relative', marginLeft: 'auto'}}>
									{
										!this.state.shipment.is_done ?
											<div id="approveStockAdjustmentButton"
											     className="ui basic green button"
											     ref={(ref) => {
												     this.$approveBtn = window.$(ref);
											     }}
											     onClick={() => {
												     if (this.$approveBtn.hasClass("loading")) {
													     return false;
												     }
												     this.$approveBtn.addClass("loading");
												     window.Global.ajax({
													     url: process.env.REACT_APP_DOMAIN + '/api/stock_adjustment/approve',
													     method: 'POST',
													     data: {
														     shipment_id: this.state.shipment.id
													     },
													     done: () => {
														     this.setState({
															     is_loading: true
														     }, () => {
															     this.view();
															     this.$approveBtn.removeClass("loading");
														     })
													     }
												     })
											     }}
											>
												อนุมัติ
											</div>
											: null
									}
									<div className="ui basic gray buttons" style={{margin: "0 0 0 1rem"}}>
										<div id="voidButton"
										     className="ui button"
										     onClick={() => {
											     this.void();
										     }}
										>
											ยกเลิก
										</div>
										<Link id="goToEdit"
										      className="ui button"
										      to={"/v2/stock_adjustment/" + this.state.shipment.id + "/edit"}
										>แก้ไข</Link>
										<div id="preview-document-quick-button"
										     className="ui button"
										     data-tooltip="พิมพ์ด่วน (โปรดใช้กับเว็บเบราว์เซอร์เวอร์ชั่นล่าสุด)"
										     data-inverted=""
										     onClick={() => {
											     window.PreviewPdf.open(this.state.shipment, 'stock_adjustment', {
												     url: process.env.REACT_APP_DOMAIN + '/api/document',
												     print: true,
											     });
										     }}
										>
											<i className="print icon" style={{margin: 0}}></i>
										</div>
										<div id="preview-document-button"
										     onClick={() => {
											     window.PreviewPdf.open(this.state.shipment, 'stock_adjustment', {
												     url: process.env.REACT_APP_DOMAIN + '/api/document'
											     });
										     }}
										     className="ui button">พิมพ์เอกสาร
										</div>
									</div>
								</div>
								: null
						}

					</div>
					<div className="ui divider" style={{margin: '0 0 14px 0'}}/>
					<div style={{margin: '0 0 50px 0'}}>
						<div className="flex row padded three column computer">
							<div className="column field">
								<label>วันที่เอกสาร</label>
								<p>{window.Global.getDateThai(this.state.shipment.doc_date, {is_show_time: false})}</p>
							</div>
							<div className="column field">
								<label>คลังสินค้า</label>
								<p>{this.state.shipment.stock ? this.state.shipment.stock.name : '-'}</p>
							</div>
							<div className="column field">
								<label>สถานะ</label>
								<p dangerouslySetInnerHTML={{__html: this.state.shipment.status_html}}/>
							</div>
							<div className="column field">
								<label>พนักงานที่รับผิดชอบ</label>
								<p>{this.state.shipment.responsibility_user ? this.state.shipment.responsibility_user.name : '-'}</p>
							</div>
							<div className="column field">
								<label>ผู้บันทึกข้อมูล</label>
								<p>
									{this.state.shipment.created_user ? this.state.shipment.created_user.name : '-'}<br/>
									{this.state.shipment.created_user ? window.Global.getDateThai(this.state.shipment.created_user.date_updated, {is_show_time: false}) : '-'}
								</p>
							</div>
							{
								this.state.shipment.approve_user ?
									<div className="column field">
										<label>ผู้อนุมัติ</label>
										<p>
											{this.state.shipment.approve_user.name}<br/>
											{window.Global.getDateThai(this.state.shipment.approve_user.date_updated, {is_show_time: false})}
										</p>
									</div>
									: null
							}
							<div className="column field">
								<label>ต้นทุน</label>
								<div className="purchase-order-sourced">
									<div className="each">
									</div>
									<a className="ui basic button"
									   href={process.env.REACT_APP_DOMAIN + "/purchase_orders/new?source=shipment&reference_id_1=" + this.state.shipment.id}
									>บันทึกต้นทุน</a>
								</div>
							</div>
						</div>
						<div className="ui basic table Table_root theme1">
							<div className="Item_root">
								<div className="thead">
									<div className="tr">
										<div className="th span8">สินค้า</div>
										<div className="th span4">สรุปจำนวนเปลี่ยนแปลง</div>
										<div className="th span4">จำนวนที่ถูกต้อง</div>
									</div>
								</div>
								<div className="tbody">
									{
										this.state.shipment.shipment_item.map((shipment_item, key) => {
											return (
												<StockAdjustmentItem
													key={key}
													mode="view"
													shipment_item={shipment_item}
													// isApprove={this.state.payment.is_approve}
												/>
											)
										})
									}
								</div>
							</div>
						</div>
					</div>
					<div className="ui grid">
						<div className="sixteen wide mobile sixteen wide tablet eight wide computer column">
							<div style={{maxWidth: '80%'}}>
								<div className="field">
									<label>หมายเหตุ</label>
									<p data-form2_text="">
										{this.state.shipment.remark && this.state.shipment.remark ? this.state.shipment.remark : '-'}
									</p>
								</div>
								<div className="field"
								     ref={(ref) => {
									     window.$(ref).form2('init', {
										     data: this.state.shipment
									     });
								     }}
								>
									<label>ไฟล์แนบ</label>
									<div data-form2_setup="true" data-form2_type="upload"
									     data-input_name="shipment_file_upload"
									     data-remove_input_name="remove_file_upload"
									     data-is_can_remove="false">
										<div className="Upload_fileRoot flex row wrap"/>
									</div>
								</div>
								<div className="field">
									<label>Tags</label>
									<p data-form2_text="">
										{
											this.state.shipment.tag.length > 0 ?
												this.state.shipment.tag.map((tag, tag_i) => {
													let _tag = tag;
													if (tag_i > 0) {
														_tag = "," + tag;
													}
													return _tag;
												})
												: '-'
										}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderList() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container">
				{/*HEADER*/}
				<div id="HeaderTop_root" className="flex row wrap" style={{marginBottom: '1rem'}}>
					<div className="flex row middle-xs center-xs">
						<div className="ui huge breadcrumb" style={{margin: '0 1em 0 0'}}>
							<Link className="active section" to="/v2/stock_adjustment">ปรับสินค้าคงคลัง</Link>
						</div>
					</div>
					<div className="right floated">
						<Link id="addProductButton" to="/v2/stock_adjustment/new"
						      className="ui positive button">ปรับสินค้าคงคลังใหม่</Link>
					</div>
				</div>
				{/*SEARCH*/}
				<div id="Search_root" className="box" style={{display: 'none', marginTop: '1rem'}}
				     ref={(ref) => {
					     let $search = window.$(ref);

					     window.Search.init({
						     $node: $search,
						     onSubmit: (data) => {
							     this.props.history.push(window.Global.getQueryStringLinkFromObject(data));
							     return false;
						     }
					     });
					     $search.find('input[name="approve_user_id"]').explorer({
						     url: process.env.REACT_APP_DOMAIN + '/api/user',
						     additionalData: {
							     limit: 30,
							     page: 1,
							     type: 'user'
						     },
						     key: 'user',
						     template: {
							     list: '<a class="item flex row">{{name}}</a>',
							     selected: {
								     text: 'name',
								     value: 'id',
								     placeholder: 'ไม่มีระบุ'
							     }
						     }
					     });
					     $search.find('input[name="created_user_id"]').explorer({
						     url: process.env.REACT_APP_DOMAIN + '/api/user',
						     additionalData: {
							     limit: 30,
							     page: 1,
						     },
						     key: 'user',
						     template: {
							     list: '<a class="item flex row">{{name}}</a>',
							     selected: {
								     text: 'name',
								     value: 'id',
								     placeholder: 'ไม่มีระบุ'
							     }
						     }
					     });
					     $search.find('input[name="stock_id"]').explorer({
						     url: process.env.REACT_APP_DOMAIN + '/api/stock',
						     additionalData: {
							     limit: 30,
							     page: 1,
						     },
						     key: 'stock',
						     template: {
							     list: '<a class="item flex row">{{name}}</a>',
							     selected: {
								     text: 'name',
								     value: 'id',
								     placeholder: 'ไม่มีระบุ'
							     }
						     }
					     });
					     $search.find('input[name="product_template_id"]').explorer({
						     url: process.env.REACT_APP_DOMAIN + '/api/product_template',
						     additionalData: {
							     limit: 30,
							     page: 1,
						     },
						     key: 'product_template',
						     template: {
							     list: '<a class="item flex row">{{name}}</a>',
							     selected: {
								     text: 'name',
								     value: 'id',
								     placeholder: 'ไม่มีระบุ'
							     }
						     }
					     });

				     }}
				>
					<form className="ui form">
						<div className="flex row wrap padded five column computer">
							<div className="column field">
								<label>เลขที่เอกสาร</label>
								<input name="search_query" data-form2_setup="" placeholder={"ค้นหาเลขที่เอกสาร"}/>
							</div>
							<div className="column field">
								<div className="field">
									<label>ช่วงวันที่รับ/จ่ายเช็ค</label>
									<div data-form_calendar="date"
									     data-input_name="start_doc_date"
									     data-placeholder="ช่วงวันที่"
									     data-end_calendar="end_doc_date"
									     data-locale="th"
									     data-initialdate=""
									/>
								</div>
							</div>
							<div className="column field">
								<div className="field">
									<label>ถึงวันที่</label>
									<div data-form_calendar="date"
									     data-input_name="end_doc_date"
									     data-placeholder="ถึงวันที่"
									     data-start_calendar="start_doc_date"
									     data-locale="th"
									     data-initialdate=""
									/>
								</div>
							</div>
							<div className="column field">
								<label>จากคลังสินค้า</label>
								<input name="stock_id" data-form2_setup="" placeholder={"จากคลังสินค้า"}/>
							</div>
							<div className="column field">
								<label>สถานะ</label>
								<div className="field">
									<select className="ui dropdown"
									        name="status"
									        data-form2_setup="">
										<option value="all">ทั้งหมด</option>
										<option value="draft">ฉบับร่าง</option>
										<option value="done">สมบูรณ์</option>
										<option value="void">ยกเลิก</option>
									</select>
								</div>
							</div>
							<div className="column field">
								<label>ผู้บันทึกข้อมูล</label>
								<input name="created_user_id" data-form2_setup="" placeholder={"ผู้บันทึก"}/>
							</div>
							<div className="column field">
								<label>ผู้บันทึกอนุมัติ</label>
								<input name="approve_user_id" data-form2_setup="" placeholder={"ผู้บันทึกอนุมัติ"}/>
							</div>
							<div className="column field">
								<label>กิจกรรมประจำ</label>
								<input name="product_template_id" data-form2_setup="" placeholder={"กิจกรรมประจำ"}/>
							</div>
							<div className="column fluid right floated">
								<label style={{opacity: 0}}>อื่นๆ</label>
								<div className="flex row wrap right floated end-xs">
									<button className="ui icon button" type="submit">
										<i className="search icon"/> ค้นหา
									</button>
								</div>
							</div>
						</div>
					</form>
				</div>
				{/*TABLE*/}
				<div className="flex row wrap">
					<div className="ui basic table can click Table_root td-top-xs" style={{marginTop: '1rem'}}>
						<div className="thead">
							<div className="tr">
								<div className="th span4">เลขที่</div>
								<div className="th span4">วันที่เอกสาร</div>
								<div className="th span4">คลังสินค้า</div>
								<div className="th span4">พนักงานที่รับผิดชอบ</div>
								<div className="th span4">สถานะ</div>
							</div>
						</div>
						<div className="tbody">
							{
								this.state.is_loading
									? <div className="tr">
										<div className="td center aligned" data-info="nodata">
											<div className="ui active centered inline small loader"/>
										</div>
									</div>
									: null
							}
							{
								!this.state.is_loading
								&& this.state.shipments.length === 0
								&& (
									!window.Global.getAllQueryStrings().page
									|| window.Global.getAllQueryStrings().page === '1'
								) ?
									<div className="tr">
										<div className="td span16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
									</div>
									: null
							}
							{
								!this.state.is_loading
								&& this.state.shipments.length > 0 ?
									this.state.shipments.map((shipment, shipment_i) => {
										return (
											<Link to={"/v2/stock_adjustment/" + shipment.id} className="tr"
											      key={shipment_i}>
												<div className="td span4">
													{shipment.desc}
												</div>
												<div className="td span4">
													{window.Global.getDateThai(shipment.doc_date, {is_show_time: false})}
												</div>
												<div className="td span4">
													{shipment.stock ? shipment.stock.name : ""}
												</div>
												<div className="td span4">
													{shipment.responsibility_user ?
														shipment.responsibility_user.name
														: null
													}
												</div>
												<div className="td span4">
													<div
														dangerouslySetInnerHTML={{__html: shipment.status_html}}/>
												</div>
											</Link>
										)
									}) : null
							}
						</div>
					</div>
				</div>
			</div>
		);
	}

	render() {
		if (this.state.mode === 'list') {
			return this.renderList();
		}

		if (this.state.is_loading) {
			return <div className="ui active centered inline loader"/>
		}
		if (this.state.mode === 'view' && this.state.shipment) {
			return this.renderView();
		}

		let isCanManageItem = this.state.mode === 'create'
			|| (
				this.state.mode === 'edit'
				&& this.state.shipment.is_done === 0
			);


		return (
			<>
				<div ref={(ref) => {
					if (!ref) return;
					this.$parent = window.$(ref);
				}}
				     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
				     className="main ui container">
					{/*HEADER*/}
					<div id="HeaderTop_root" className="flex row wrap" style={{marginBottom: '1rem'}}>
						<div className="flex row middle-xs center-xs">
							<div className="ui huge breadcrumb" style={{margin: '0 1em 0 0'}}>
								<Link className="active section" to="/v2/stock_adjustment">ปรับสินค้าคงคลัง</Link>
								{
									this.state.shipment ?
										<>
											<span className="divider" style={{margin: '0 1rem'}}>/</span>
											<Link to={"/v2/stock_adjustment/" + this.state.shipment.id}
											      className="section">
												{this.state.shipment ? this.state.shipment.desc : ''}
											</Link>
										</>
										: null
								}
								<span className="divider" style={{margin: '0px 1rem'}}>/</span>
								<div className="section active">{this.state.mode === "create" ? "ใหม่" : "แก้ไข"}</div>
							</div>
						</div>
						{/*<div className="right floated">*/}
						{/*	<Link id="addProductButton" to="/v2/stock_adjustment/new"*/}
						{/*	      className="ui positive button">ปรับสินค้าคงคลังใหม่</Link>*/}
						{/*</div>*/}
					</div>
					{/*SEARCH*/}
					<form id="StockAdjustment_root"
					      ref={(ref) => {
						      window.$(ref).form2('setup');
						      window.$(ref).form2('submit', {
							      method: this.state.mode === 'create' ? 'POST' : 'PUT',
							      url: process.env.REACT_APP_DOMAIN + '/api/stock_adjustment',
							      beforeSent: (object) => {
								      // console.log(object);
								      // return;
								      return object;
							      },
							      loadingButton: window.$(ref).find('.button'),
							      onSuccess: (response) => {
								      window.Global.messageTop({
									      type: 'positive',
									      message: 'บันทึกข้อมูลเรียบร้อย'
								      });
								      // console.log(response);
								      if (this.state.mode === 'edit') {
									      this.props.history.push({
										      pathname: '/v2/stock_adjustment/' + this.state.shipment.id,
										      state: null
									      });
								      }
								      if (this.state.mode === 'create') {
									      this.props.history.push({
										      pathname: '/v2/stock_adjustment/' + response.shipment_id,
										      state: null
									      });
								      }
							      }
						      });
					      }}
					      className={this.state.is_loading ? "ui form ui tall stacked loading segment" : "ui form ui tall stacked segment"}
					      autoComplete="off">
						<div className="flex row wrap middle-xs Signature_head" style={{padding: '2px 0 14px 0'}}>
							<h2 style={{margin: 0}}>
								{this.state.mode === 'edit' ? 'แก้ไข' : null}
								ปรับสินค้าคงคลัง
								{this.state.mode === 'create' ? 'ใหม่' : null}
							</h2>
						</div>
						<div className="ui divider" style={{margin: '0 0 14px 0'}}/>
						<div className={"flex row wrap padded three column computer"}>
							<div className="column field required custom-running-number">
								<label className="flex row">
									เลขที่เอกสาร
									{
										this.state.mode === 'create' ?
											<span className="ui checkbox"
											      data-form2_setup="true"
											      style={{marginLeft: '0.5rem'}}>
										      <input type="checkbox"
										             tabIndex="-1"
										             className="hidden"
										             name="is_code_generate_auto"
										             id={"is_code_generate_auto"}
										             defaultChecked="checked"/>
										      <label htmlFor="is_code_generate_auto"
										             style={{paddingLeft: '1.5em'}}>Auto</label>
										      </span>
											:
											null
									}
								</label>
								<input type="text" name={"shipment_no"}/>
							</div>
							<div className="column field required">
								<label>วันที่เอกสาร</label>
								<div data-form_calendar="date"
								     data-input_name="doc_date"
								     data-placeholder={"วันที่เอกสาร"}
								     data-locale="th"
								     data-initialdate={"now"}
								/>
							</div>
							<div className="column field required">
								<label>คลังสินค้า</label>
								{
									isCanManageItem
										?
										<input name={"stock_id"}/>
										:
										this.state.shipment.stock.name
								}
							</div>
							<div className="column field required">
								<label>พนักงานที่รับผิดชอบ</label>
								<input name={"responsibility_user_id"}/>
							</div>
							{
								this.state.mode === 'create' ?
									<div className="column field required">
										<label>กิจกรรมประจำ</label>
										<input name={"product_template_id"}/>
									</div>
									: null
							}
						</div>
						<div className="flex row padded wrap one column computer" style={{marginTop: '2rem'}}>
							<div className="column">
								<div className="ui basic table Table_root theme1 td-top-xs">
									<div className="thead">
										<div className="tr">
											{
												this.state.mode === 'create'
												|| (
													this.state.mode === 'edit'
													&& this.state.shipment.is_done === 0
												)
													?
													<>
														<div className="th span4">รายละเอียด</div>
														<div className="th span4">จำนวนในคลัง</div>
														<div className="th span4">จำนวนที่ถูกต้อง</div>
														<div className="th span4">สรุปจำนวนเปลี่ยนแปลง</div>
														<div className="th span4">ต้นทุน</div>
													</>
													:
													<>
														<div className="th span8">รายละเอียด</div>
														<div className="th span4">สรุปจำนวนเปลี่ยนแปลง</div>
														<div className="th span4">จำนวนที่ถูกต้อง</div>
													</>
											}
										</div>
									</div>
									<div className="tbody Item_root">
										{
											this.state.mode === 'edit'
											&&
											this.state.shipment.shipment_item.map((shipment_item, key) => {
												if (this.state.shipment.is_done === 0) {
													return (
														<StockAdjustmentItem
															key={key}
															mode="edit"
															shipment={this.state.shipment}
															shipment_item={shipment_item}
															// isApprove={this.state.payment.is_approve}
														/>
													)
												}
												return <StockAdjustmentItem
													key={key}
													mode="view"
													shipment_item={shipment_item}
												/>
											})
										}
									</div>
									{
										isCanManageItem
											?
											<div className="tr">
												<div className="td flex span16 center-xs">
													<div>
														<div className="ui basic button"
														     onClick={() => {
															     window.GlobalFunc.reactToDom(
																     window.$(this.$parent).find('.Item_root'),
																     StockAdjustmentItem, {
																	     mode: 'create',
																	     shipment_item: {
																		     quantity: 1,
																		     ratio: 1,
																		     price: 0,
																	     }
																     }
															     );
														     }}
														>
															<i className="plus icon"/>
															เพิ่มรายการ
														</div>
													</div>
												</div>
											</div>
											:
											null
									}
								</div>
							</div>
						</div>
						<div className="flex row wrap">
							<div className="col-xs-16 col-lg-11">
								<div style={{maxWidth: '50%'}}>
									<div className="field">
										<label>หมายเหตุ</label>
										<textarea className="ui dropdown" name="remark"/>
									</div>
									<div className="field">
										<label>ไฟล์แนบ</label>
										<div id="Upload_fileRoot"
										     data-form2_setup="done" data-form2_type="upload"
										     data-input_name="shipment_file_upload"
										     data-remove_input_name="remove_file_upload"
										     data-is_can_remove="true"
										/>
									</div>
									<div className="field">
										<label>Tags</label>
										<input type="text" name="tag[]"/>
									</div>
								</div>
							</div>
						</div>
						<br/>
						<br/>
						<div className="ui error message"/>
						<div className="flex row">
							<div className="right floated">
								{
									this.state.shipment
									&& this.state.shipment.id
										?
										<input type={"hidden"}
										       name={"shipment_id"}
										       defaultValue={this.state.shipment.id}
										/>
										: null
								}
								<input type={"hidden"}
								       name={"is_done"}
								/>
								<Link
									to={this.state.mode === 'create' ? '/v2/stock_adjustment' : '/v2/stock_adjustment/' + this.state.shipment.id}
									className={"ui button"}>ยกเลิก</Link>
								{
									this.state.mode === 'create'
										?
										<>
											<button id="submitDraftButton"
											        className="ui button"
											        type="button"
											        onClick={() => {
												        let $form = this.$parent.find('form');
												        $form.find('input[name="is_done"]').val(0);
												        $form.trigger('submit');
											        }}
											>
												บันทึกฉบับร่าง
											</button>
											<button id="submitButton"
											        className="ui positive button"
											        type="button"
											        onClick={() => {
												        let $form = this.$parent.find('form');
												        $form.find('input[name="is_done"]').val(1);
												        $form.trigger('submit');
											        }}>
												บันทึกและอนุมัติปรับสินค้าคงคลัง
											</button>
										</>
										: null
								}
								{
									this.state.mode === 'edit'
									&&
									<button id="submitButton"
									        className="ui positive button"
									        type="button"
									        onClick={() => {
										        let $form = this.$parent.find('form');
										        $form.find('input[name="is_done"]').val(this.state.shipment.is_done);
										        $form.trigger('submit');
									        }}>
										บันทึก
									</button>
								}
							</div>
						</div>
					</form>
				</div>
			</>
		);
	}

	void() {
		window.Global.confirm({
			title: 'ยืนยันลบข้อมูล',
			content: '<form class="ui form">\n\t<p>โปรดยืนยันลบข้อมูล การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>',
			cancel_text: 'ไม่ดำเนินการ',
			approve_text: 'ลบข้อมูล',
			onShowToSetupForm: ($modal) => {
				$modal.find('form').form2('setup');
				$modal.find('form').form2('submit', {
					method: 'DELETE',
					url: process.env.REACT_APP_DOMAIN + '/api/stock_adjustment',
					loadingButton: $modal.find('.button.approve'),
					beforeSent: (data) => {
						data.shipment_id = this.state.shipment.id;
						return data;
					},
					onSuccess: (response) => {
						$modal.modal('hide');
						window.Global.messageTop({
							type: 'positive',
							message: 'ลบข้อมูลสำเร็จ'
						});
						this.view();
						// console.log(response);
						// this.props.history.push({
						//    pathname: '/v2/stock_adjustment/' + this.state.shipment.id,
						//    state: null
						// });
					}
				});
			}
		});
	}
}


class StockAdjustmentItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			mode: props.mode,
			id: props.shipment_item.id || '',
			description: props.shipment_item.description || '',
			quantity_ship: props.shipment_item.quantity_ship || '',
			ratio: props.shipment_item.ratio || '',
			product: props.shipment_item.product || false,
			shipment_item_serial_number: props.shipment_item.shipment_item_serial_number || [],

			product_cost: props.shipment_item.product_cost || false,
		};
	}

	componentDidMount() {
		window.$(this.ref).find('textarea[name="item[][description]"]').autoHeight();
	}

	remove() {
		window.$(this.ref).remove();
	}

	renderView() {
		return (
			<div
				ref={(ref) => {
					this.ref = ref;
				}}
				className="tr Item_each"
			>
				<div className="td span8">
					{
						this.state.mode === 'view' ?
							<div className="flex row middle-xs">
								<div className="ui avatar image" style={{marginRight: '0.8rem'}}>
									<img src={this.props.shipment_item.product.product_image_file_upload.url}
									     alt={"stockAdjustment"}/>
								</div>
								<div>
									<div style={{marginTop: "0.3rem"}}>{this.props.shipment_item.product.name}</div>
									{
										this.props.shipment_item.description ?
											<div
												style={{whiteSpace: 'pre-line'}}>{this.props.shipment_item.description}</div>
											: null
									}
								</div>
							</div>
							: null
					}
				</div>
				<div className="td span4">
					<div className="flex row">
						<div>
							{
								this.state.mode === 'view' ?
									<div>
										{this.props.shipment_item.quantity_action2}
									</div>
									:
									null
							}
						</div>
					</div>
				</div>
				<div className="td span4">
					<div className="flex row">
						<div>
							{
								this.state.mode === 'view' ?
									<div>
										{this.props.shipment_item.quantity_ship2}
									</div>
									:
									null
							}
						</div>
					</div>
				</div>
			</div>
		);
	}

	render() {
		if (this.state.mode === 'view') {
			return this.renderView();
		}

		return (
			<div data-product_id={this.state.product.id}
			     ref={(ref) => {
				     if (!ref) return;
				     this.$item = window.$(ref);
			     }}
			     className="tr Item_each"
			>
				<div className="td span4">
					<div>
						{
							!this.state.product
							&&
							<div ref={(ref) => {
								let $e = window.$(ref).find('input[name="search_product_name"]').explorer({
									url: process.env.REACT_APP_DOMAIN + '/api/product',
									additionalData: {
										limit: 30,
										page: 1,
										product_serial_number: true,
										for: 'stock_adjustment',
										stock_id: window.$('input[name="stock_id"]').val(),
										type: 'normal'
									},
									key: 'product',
									template: {
										list: (value) => {
											let search = window.$(ref).val();
											return window.GlobalTemplate.getProductSearchList(search, value);
										},
										selected: {
											text: 'name',
											value: 'id',
											placeholder: ''
										}
									},
									onSelected: (product) => {
										let $parent = $e.closest('form');
										let stock1 = Helper.getProductStock(
											product,
											$parent.find('input[name="stock_id"]').val()
										);
										this.setState({
											$parent: $parent,
											mode: 'create',
											id: '',
											quantity_ship: stock1.on_hand,
											ratio: product.sell_price[0].ratio,
											product: product,
										}, () => {
											if (window.$('.Item_root').find('div[data-product_id="' + this.state.product['id'] + '"]').length > 1) {
												this.$item.remove();
												return false;
											}
										})
									}
								});
								setTimeout(() => {
									this.$item.find('input[name="search"]').focus();
								}, 100);
							}}>
								<input type="text"
								       name="search_product_name"
								       placeholder="สินค้า"
								/>
							</div>
						}
						{
							/*
							หลังเลือกสินค้าแล้ว
							 */
							this.state.product
								?
								<div className="flex row">
									<img className="ui avatar image"
									     src={this.state.product.product_image_file_upload.url}
									     alt={"Product"}
									/>
									<div className="product">
										<div className="product-name">{this.state.product.name}</div>
										{
											false
											&& this.state.product.is_serial_number
												?
												<div className="serial-number"
												     style={{
													     marginTop: '5px'
												     }}>
													<input type="text"
													       name="serial_number[]"
													       ref={(ref) => {
														       let $e = window.$(ref).explorer({
															       url: process.env.REACT_APP_DOMAIN + '/api/product_serial_number',
															       multiple: true,
															       additionalData: () => {
																       let $parent = $e.closest('#ShipmentStockTransfer_root');

																       return {
																	       page: 1,
																	       limit: 30,
																	       product_id: this.state.product.id,
																	       product_serial_number: true,
																	       store_in_stock_id: $parent.find('input[name="stock_id"]').val(),
																	       exclude_product_serial_number_id: $e.explorer('get value')
																       }
															       },
															       key: 'product_serial_number',
															       template: {
																       list: (value) => {
																	       let search = $e.find('input[name="search"]').val();
																	       return window.GlobalTemplate.getProductSerialNumberSearchList(search, value);
																       },
																       selected: {
																	       text: 'serial_number',
																	       value: 'id',
																	       placeholder: 'ค้นหา Serial Number'
																       }
															       },
															       onSelected: () => {
																       this.$item.find('input[name="user_input_quantity"]')
																	       .val($e.explorer('get value').length)
																	       .trigger('keyup');
															       },
															       onUnSelected: () => {
																       this.$item.find('input[name="user_input_quantity"]')
																	       .val($e.explorer('get value').length)
																	       .trigger('keyup');
															       }
														       });

														       if (this.state.mode === 'edit') {
															       setTimeout(() => {
																       for (let shipment_item_serial_number of this.state.shipment_item_serial_number) {
																	       $e.explorer('set value', shipment_item_serial_number.product_serial_number);
																       }
															       }, 100);
														       }
													       }}
													/>
												</div>
												: null
										}
									</div>
									<input type="hidden" name="item[][product_id]" value={this.state.product.id}/>
								</div>
								: null
						}
					</div>
				</div>
				<div className="td span4">
					<div id="on_hand"/>
				</div>
				<div className="td span4">
					<div className="flex row">
						<div>
							{
								// this.state.product ?
								// 	<div id={"ratio"}
								// 	     ref={(ref) => {
								// 		     ProductsetupQuantityAndRatio.setupQuantityAndRatio(ref, this.state.product, {
								// 			     onChangeQuantityAndRatio: (item, $e) => {
								// 				     // let $parent = $e.closest('form');
								// 				     let $item = $e.closest('.Item_each');
								//
								// 				     let qty = item.quantity;
								// 				     if (qty > stock1.on_hand) {
								// 					     $item.find('.Item_quantityChanged').text(
								// 						     '+' +
								// 						     window.GlobalFunc.getUnitNameByQuantity2({
								// 							     product: this.state.product,
								// 							     quantity: qty - stock1.on_hand,
								// 							     ratio: 1
								// 						     })['text']
								// 					     );
								// 				     } else if (qty === stock1.on_hand) {
								// 					     $item.find('.Item_quantityChanged').text(0);
								// 				     } else {
								// 					     $item.find('.Item_quantityChanged').text(
								// 						     '-' +
								// 						     window.GlobalFunc.getUnitNameByQuantity2({
								// 							     product: this.state.product,
								// 							     quantity: stock1.on_hand - qty,
								// 							     ratio: 1
								// 						     })['text']
								// 					     );
								// 				     }
								// 			     },
								// 			     quantity: stock1.on_hand,
								// 			     quantity_input_name: "item[][quantity_ship]",
								// 			     ratio_input_name: "item[][ratio]",
								// 		     });
								// 	     }}
								// 	/>
								// 	: '-'
							}
							{
								this.state.product
									?
									<div>
										<div ref={(ref) => {
											window.GlobalFunc.setupQuantityAndRatio(window.$(ref), {
												product: this.state.product,
												quantity: this.state.quantity_ship,
												input_quantity: 'item[][quantity_ship]',
												ratio: this.state.ratio,
												input_ratio: 'item[][ratio]',
												quantityReadOnly: false,
												allowNegative: true,
												rootClass: '',
												onChange: (item, $e) => {
													let $item = $e.closest('.Item_each');

													let $stock = window.$('input[name="stock_id"]');
													let stock1 = Helper.getProductStock(
														this.state.product,
														$stock.length === 0
															? this.props.shipment.stock_id
															: $stock.val()
													);

													$item.find('#on_hand').text(
														window.GlobalFunc.getUnitNameByQuantity2({
															product: this.state.product,
															quantity: stock1.on_hand,
															ratio: this.state.product.sell_price[0].ratio
														})['text']
													);

													let qty = item.quantity;

													if (qty > stock1.on_hand) {
														$item.find('.Item_quantityChanged').text(
															'+' +
															window.GlobalFunc.getUnitNameByQuantity2({
																product: this.state.product,
																quantity: qty - stock1.on_hand,
																ratio: 1
															})['text']
														);
													} else if (qty === stock1.on_hand) {
														$item.find('.Item_quantityChanged').text(0);
													} else {
														$item.find('.Item_quantityChanged').text(
															'-' +
															window.GlobalFunc.getUnitNameByQuantity2({
																product: this.state.product,
																quantity: stock1.on_hand - qty,
																ratio: 1
															})['text']
														);
													}
												}
											});

											// if (this.state.product.is_serial_number) {
											// 	window.$(ref).find('.Item_selectUnitName').addClass('active');
											// 	window.$(ref).find('.Item_selectUnitName').dropdown('set selected', '0');
											// 	window.$(ref).find('input[name="user_input_quantity"]')
											// 		.val(0)
											// 		.attr('readonly', 'readonly')
											// 		.trigger('keyup');
											// }
										}}
										/>
									</div>
									: '-'
							}
						</div>
					</div>
				</div>
				<div className="td span4">
					<div className="flex row">
						<div>
							{
								this.state.product ?
									<div className="Item_quantityChanged">
										0
									</div>
									: '-'
							}
						</div>
					</div>
				</div>
				<div className="td span4">
					<div className="flex row">
						<div>
							{
								false
									?
									this.state.product_cost
										?
										<>
											<div>
												<label>ราคา</label> {this.state.product_cost.price.format(2)}
												<span className={"link"}
												      style={{marginLeft: 5}}
												      onClick={() => {
													      window.Global.reactToDom(window.$('body'),
														      <ProductCostModal
															      product_cost={this.state.product_cost}
															      onSuccess={(data) => {
																      let product_cost = {...this.state.product_cost};
																      product_cost.tax = data.tax;
																      product_cost.tax_type = data.tax_type;
																      product_cost.price = data.price;
																      this.setState({
																	      product_cost: product_cost
																      })
															      }}
															      onCancel={() => {
																      this.setState({
																	      product_cost: false
																      })
															      }}
														      />
													      )
												      }}
												>แก้ไขมูลค่า</span>
												<div className={"text-label"}>
													{
														this.state.product_cost.tax_type === 'has_vat' ?
															<span className="ui label mini brown manage-button">tax 7%</span>
															: null
													}
													{
														this.state.product_cost.tax_type !== 'has_vat' ?
															<span className="ui label mini brown manage-button"
															      style={{
																      opacity: 0.5,
																      textDecoration: 'line-through',
																      filter: 'grayscale(100%)'
															      }}
															>tax 0%</span>
															: null
													}
												</div>
												<input type="hidden" name="item[][tax_type]"
												       value={this.state.product_cost ? this.state.product_cost.tax_type : "exclude_vat"}/>
												<input type="hidden" name={"item[][tax]"}
												       value={this.state.product_cost ? this.state.product_cost.tax : "7"}/>
												<input type="hidden" name={"item[][price]"}
												       value={this.state.product_cost ? this.state.product_cost.price : 0}/>
											</div>
										</>
										:
										<button type={"button"}
										        className={"ui button basic"}
										        onClick={() => {
											        window.Global.reactToDom(window.$('body'),
												        <ProductCostModal
													        product_cost={this.state.product_cost}
													        onSuccess={(data) => {
														        let product_cost = {...this.state.product_cost};
														        product_cost.tax = data.tax;
														        product_cost.tax_type = data.tax_type;
														        product_cost.price = data.price;
														        this.setState({
															        product_cost: product_cost
														        })
														        console.log(data);
													        }}
												        />
											        )
										        }}
										>
											บันทึกต้นทุน
										</button>
									: null
							}
						</div>
						<div className="right floated"
						     style={
							     this.props.is_can_remove !== undefined
							     && !this.props.is_can_remove
								     ? {display: 'none'}
								     : null
						     }>
							<input type="hidden" name="item[][is_deleted]" defaultValue={0}/>
							<input type="hidden" name="item[][id]" value={this.state.id || ''}/>
							<button type={"button"}
							        className={"ui icon button remove"}
							        onClick={() => {
								        if (!this.state.id) {
									        this.$item.remove();
									        ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(this));
								        } else {
									        this.$item.addClass('disabled');
									        this.$item.find('input[name="item[][is_deleted]"]').val(1);
								        }
							        }}
							>
								<i className="remove icon" style={{margin: 0}}/>
							</button>
						</div>
					</div>
				</div>
				<div className="disabled-wrapper flex row middle-xs">
					<div className="right floated">
						<div className="ui button basic"
						     onClick={() => {
							     this.$item.removeClass('disabled');
							     this.$item.find('input[name="item[][is_deleted]"]').val(0);
						     }}>
							ย้อนกลับ
						</div>
					</div>
				</div>
			</div>
		);
	}
}

class ProductCostModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			tax: props.product_cost ? props.product_cost.tax : '7',
			tax_type: props.product_cost ? props.product_cost.tax_type : 'has_vat',
			price: props.product_cost ? props.product_cost.price : 0,
		}
	}

	changeTax(value) {
		this.taxTypeInput.val(value);
		if (value === 'has_vat') {
			this.taxInput.val(7);
		}
		if (value !== 'has_vat') {
			this.taxInput.val(0);
		}
	}

	render() {
		console.log(this.state);
		return (
			<div>
				<Modal className="ui modal mini"
				       closable={false}
				       onShow={($modal) => {
					       this.$modal = window.$($modal);
				       }}
				       onApprove={(e) => {
					       let data = this.$form.serializeObject();
					       delete data.type;
					       this.props.onSuccess(data);
					       this.$modal.modal('hide');
				       }}
				>
					<div className={"header"}>
						<h1 className={"ui header"}>
							บันทึกต้นทุน
						</h1>
					</div>
					<div className="content">
						<form className={"ui form"}
						      ref={(ref) => {
							      this.$form = window.$(ref);
						      }}
						>
							<div className="field">
								<label>ราคา</label>
								<input type={"number"} name={"price"} defaultValue={this.state.price}/>
							</div>
							<div className="field column required">
								<div className="grouped fields">
									<div className="field">
										<div className="ui radio checkbox"
										     data-form2_setup="done"
										     ref={(ref) => {
											     window.$(ref).checkbox({
												     onChecked: () => {
													     let value = window.$(ref).find('input').val();
													     this.changeTax(value);
												     }
											     })
										     }}
										>
											<input type="radio"
											       name="type"
											       tabIndex="0"
											       className="hidden"
											       defaultValue="has_vat"
											       defaultChecked={this.state.tax_type === "has_vat"}
											/>
											<label>คิดภาษีมูลค่าเพิ่ม 7%</label>
										</div>
									</div>
									<div className="field">
										<div className="ui radio checkbox"
										     data-form2_setup="done"
										     ref={(ref) => {
											     window.$(ref).checkbox({
												     onChecked: () => {
													     let value = window.$(ref).find('input').val();
													     this.changeTax(value);
												     }
											     })
										     }}
										>
											<input type="radio"
											       name="type"
											       tabIndex="0"
											       className="hidden"
											       defaultValue="except_vat"
											       defaultChecked={this.state.tax_type === "except_vat"}
											/>
											<label>ยกเว้นภาษีมูลค่าเพิ่ม</label>
										</div>
									</div>
									<div className="field">
										<div className="ui radio checkbox"
										     data-form2_setup="done"
										     ref={(ref) => {
											     window.$(ref).checkbox({
												     onChecked: () => {
													     let value = window.$(ref).find('input').val();
													     this.changeTax(value);
												     }
											     })
										     }}
										>
											<input type="radio"
											       name="type"
											       tabIndex="0"
											       className="hidden"
											       value="zero_vat"
											       defaultChecked={this.state.tax_type === "zero_vat"}
											/>
											<label>ภาษีศูนย์</label>
										</div>
									</div>
								</div>
							</div>
							<div className="field column">
								<label htmlFor="">อัตราภาษี</label>
								<input
									ref={(ref) => {
										this.taxTypeInput = window.$(ref)
									}}
									type="hidden"
									name="tax_type"
									defaultValue={this.state.tax_type}
								/>
								<input
									ref={(ref) => {
										this.taxInput = window.$(ref)
									}}
									type="text"
									name="tax"
									defaultValue={this.state.tax}
									readOnly={true}
								/>
							</div>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="ui button"
							     ref={(ref) => {
								     this.$cancle = window.$(ref)
							     }}
							     onClick={() => {
								     if (this.$cancle.addClass("loading")) {
									     return false;
								     }
								     this.$cancle.addClass("loading");
								     this.props.onCancel();
								     this.$modal.modal('hide');
							     }}
							>
								ยกเลิกต้นทุน
							</div>
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div className="ui approve green right button"
								     ref={(ref) => {
									     this.$approve = window.$(ref)
								     }}
								>บันทึกข้อมูล
								</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}
